import script from "./UserActionsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserActionsModal.vue?vue&type=script&setup=true&lang=ts"

import "./UserActionsModal.vue?vue&type=style&index=0&id=03dac433&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03dac433"]])

export default __exports__